import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Add this import

const WelcomeSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null);
  const navigate = useNavigate(); // Add this hook

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  // Updated navigation handler function with actual routing
  const handleNavigation = (href) => {
    navigate(href); // Use React Router's navigate
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  const handleExploreClick = () => {
    handleNavigation('/about/profile'); // Navigate to Our Profile page
  };

  const handleFeaturesClick = () => {
    handleNavigation('/service'); // Navigate to Our Services page
  };

  const styles = {
    section: {
      padding: '4rem 0',
      backgroundColor: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      minHeight: '100vh'
    },
    container: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '6rem',
      alignItems: 'flex-start'
    },
    leftColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem'
    },
    mainHeading: {
      fontSize: '3.5rem',
      fontWeight: '700',
      color: '#1a1a1a',
      lineHeight: '1.1',
      margin: '0 0 2rem 0',
      letterSpacing: '-0.02em'
    },
    contentText: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      marginBottom: '2rem'
    },
    paragraph: {
      color: '#6b7280',
      lineHeight: '1.7',
      margin: '0',
      fontSize: '1.1rem'
    },
    buttonGroup: {
      display: 'flex',
      gap: '1.5rem',
      marginTop: '1.5rem'
    },
    btnBase: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem 2.5rem',
      borderRadius: '0.75rem',
      fontWeight: '600',
      fontSize: '1.1rem',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      minWidth: '180px'
    },
    btnPrimary: {
      background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
      color: 'white',
      boxShadow: '0 2px 4px rgba(34, 197, 94, 0.2)'
    },
    btnSecondary: {
      background: 'linear-gradient(135deg, #4ade80 0%, #22c55e 100%)',
      color: 'white',
      boxShadow: '0 2px 4px rgba(74, 222, 128, 0.2)'
    },
    btnIcon: {
      width: '1.25rem',
      height: '1.25rem',
      marginLeft: '0.5rem'
    },
    rightColumn: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '2rem'
    },
    faqSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0'
    },
    faqItem: {
      borderBottom: '1px solid #e5e7eb',
      padding: '2rem 0'
    },
    faqButton: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'left',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '0',
      transition: 'color 0.2s ease'
    },
    faqQuestion: {
      fontSize: '1.4rem',
      fontWeight: '600',
      color: '#1f2937',
      lineHeight: '1.3',
      flex: '1',
      marginRight: '1.5rem'
    },
    faqArrow: {
      width: '1.5rem',
      height: '1.5rem',
      color: '#6b7280',
      transition: 'transform 0.3s ease, color 0.2s ease',
      flexShrink: '0'
    },
    faqArrowOpen: {
      transform: 'rotate(180deg)',
      color: '#22c55e'
    },
    faqAnswer: {
      marginTop: '1.5rem',
      color: '#6b7280',
      lineHeight: '1.6',
      fontSize: '1rem',
      animation: 'fadeIn 0.3s ease-out'
    },
    benefitsList: {
      padding: '0',
      margin: '0'
    },
    benefitsUl: {
      listStyle: 'none',
      padding: '0',
      margin: '0',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    benefitItem: {
      display: 'flex',
      alignItems: 'flex-start',
      color: '#374151',
      fontSize: '1rem'
    },
    bullet: {
      width: '8px',
      height: '8px',
      backgroundColor: '#22c55e',
      borderRadius: '50%',
      marginTop: '0.5rem',
      marginRight: '1rem',
      flexShrink: '0'
    },
    disclaimer: {
      fontSize: '0.875rem',
      color: '#6b7280',
      fontStyle: 'italic',
      marginTop: '1rem',
      padding: '1rem',
      backgroundColor: '#f9fafb',
      borderRadius: '0.5rem',
      border: '1px solid #e5e7eb'
    }
  };

  return (
    <>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .btn-hover-primary:hover {
          background: linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3) !important;
        }
        
        .btn-hover-secondary:hover {
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%) !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(74, 222, 128, 0.3) !important;
        }
        
        .faq-hover:hover {
          color: #22c55e !important;
        }
        
        @media (max-width: 1024px) {
          .responsive-grid {
            grid-template-columns: 1fr !important;
            gap: 4rem !important;
          }
          .responsive-heading {
            font-size: 3rem !important;
          }
          .responsive-container {
            padding: 0 1.5rem !important;
          }
        }
        
        @media (max-width: 768px) {
          .responsive-container {
            padding: 0 1rem !important;
          }
          .responsive-grid {
            gap: 3rem !important;
          }
          .responsive-heading {
            font-size: 2.5rem !important;
          }
          .responsive-buttons {
            flex-direction: column !important;
          }
          .responsive-btn {
            width: 100% !important;
            min-width: auto !important;
          }
          .responsive-question {
            font-size: 1.2rem !important;
          }
          .responsive-right {
            padding-top: 0 !important;
          }
        }
        
        @media (max-width: 640px) {
          .responsive-heading {
            font-size: 2rem !important;
          }
          .responsive-text {
            font-size: 1rem !important;
          }
          .responsive-question {
            font-size: 1.1rem !important;
          }
        }
      `}</style>
      
      <section style={styles.section}>
        <div style={{...styles.container}} className="responsive-container">
          <div style={{...styles.grid}} className="responsive-grid">
            {/* LEFT COLUMN - Welcome Content */}
            <div style={styles.leftColumn}>
              <h2 style={{...styles.mainHeading}} className="responsive-heading">
                Welcome to WinNest
              </h2>
              
              <div style={styles.contentText}>
                <p style={{...styles.paragraph}} className="responsive-text">
                  Planning for your home, travel, and retirement goals is important for your financial well-being. 
                  At WinNest, we provide mutual fund distribution services and recommend suitable mutual fund schemes 
                  based on your risk profile and financial objectives. Our scheme recommendations are based 
                  on thorough research and analysis.
                </p>
                <p style={{...styles.paragraph}} className="responsive-text">
                  We offer convenient online services for account opening, investment processing, performance 
                  tracking, and redemptions. Our qualified Financial Advisors are committed to providing you 
                  with professional investment guidance and support throughout your investment journey.
                </p>
              </div>
              
              {/* Buttons */}
              <div style={{...styles.buttonGroup}} className="responsive-buttons">
                <button 
                  style={{...styles.btnBase, ...styles.btnPrimary}} 
                  className="btn-hover-primary responsive-btn"
                  onClick={handleExploreClick}
                >
                  Learn more
                  <svg style={styles.btnIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </button>
                <button 
                  style={{...styles.btnBase, ...styles.btnSecondary}} 
                  className="btn-hover-secondary responsive-btn"
                  onClick={handleFeaturesClick}
                >
                  View services
                  <svg style={styles.btnIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </button>
              </div>
            </div>

            {/* RIGHT COLUMN - Benefits + FAQs */}
            <div style={{...styles.rightColumn}} className="responsive-right">
              <div style={styles.faqSection}>
                {/* Benefits as FAQ Item */}
                <div style={{...styles.faqItem, paddingTop: '0'}}>
                  <button
                    onClick={() => toggleFAQ('benefits')}
                    style={styles.faqButton}
                    className="faq-hover"
                  >
                    <span style={{...styles.faqQuestion}} className="responsive-question">
                      What are the potential benefits of investing in Mutual Funds?
                    </span>
                    <svg
                      style={{
                        ...styles.faqArrow,
                        ...(openFAQ === 'benefits' ? styles.faqArrowOpen : {})
                      }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openFAQ === 'benefits' && (
                    <div style={styles.faqAnswer}>
                      <div style={styles.benefitsList}>
                        <ul style={styles.benefitsUl}>
                          <li style={styles.benefitItem}>
                            <span style={styles.bullet}></span>
                            <span>Potential tax benefits (subject to applicable laws)</span>
                          </li>
                          <li style={styles.benefitItem}>
                            <span style={styles.bullet}></span>
                            <span>Potential for capital appreciation over long term</span>
                          </li>
                          <li style={styles.benefitItem}>
                            <span style={styles.bullet}></span>
                            <span>May help in wealth preservation against inflation</span>
                          </li>
                          <li style={styles.benefitItem}>
                            <span style={styles.bullet}></span>
                            <span>AMFI-registered Mutual Fund Distributor for investor protection</span>
                          </li>
                        </ul>
                      </div>
                      <div style={styles.disclaimer}>
                        *Mutual Fund investments are subject to market risks. Past performance is not indicative of future results.
                      </div>
                    </div>
                  )}
                </div>

                {/* FAQ Item 1 */}
                <div style={styles.faqItem}>
                  <button
                    onClick={() => toggleFAQ(1)}
                    style={styles.faqButton}
                    className="faq-hover"
                  >
                    <span style={{...styles.faqQuestion}} className="responsive-question">
                      What is the difference between Equity Funds and Debt Funds?
                    </span>
                    <svg
                      style={{
                        ...styles.faqArrow,
                        ...(openFAQ === 1 ? styles.faqArrowOpen : {})
                      }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openFAQ === 1 && (
                    <div style={styles.faqAnswer}>
                      Equity funds primarily invest in stocks and equity-related instruments, offering potential for higher returns 
                      but with higher market risk. Debt funds invest in bonds, government securities, and other fixed-income 
                      instruments, generally offering more stable returns with relatively lower risk compared to equity funds. 
                      Both are subject to market risks and regulatory changes.
                    </div>
                  )}
                </div>

                {/* FAQ Item 2 */}
                <div style={styles.faqItem}>
                  <button
                    onClick={() => toggleFAQ(2)}
                    style={styles.faqButton}
                    className="faq-hover"
                  >
                    <span style={{...styles.faqQuestion}} className="responsive-question">
                      How much life insurance coverage should I consider?
                    </span>
                    <svg
                      style={{
                        ...styles.faqArrow,
                        ...(openFAQ === 2 ? styles.faqArrowOpen : {})
                      }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openFAQ === 2 && (
                    <div style={styles.faqAnswer}>
                      Life insurance coverage typically ranges from 8-12 times your annual income, depending on your 
                      financial obligations, dependents' needs, existing assets, and future goals. The exact amount 
                      should be determined based on your specific financial situation. We recommend consulting with 
                      a qualified financial advisor to assess your individual needs and circumstances.
                    </div>
                  )}
                </div>

                {/* FAQ Item 3 */}
                <div style={styles.faqItem}>
                  <button
                    onClick={() => toggleFAQ(3)}
                    style={styles.faqButton}
                    className="faq-hover"
                  >
                    <span style={{...styles.faqQuestion}} className="responsive-question">
                      When should one consider starting investments?
                    </span>
                    <svg
                      style={{
                        ...styles.faqArrow,
                        ...(openFAQ === 3 ? styles.faqArrowOpen : {})
                      }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openFAQ === 3 && (
                    <div style={styles.faqAnswer}>
                      Starting investments early can potentially benefit from the power of compounding over time. 
                      However, the right time to invest depends on your financial stability, risk capacity, 
                      investment goals, and personal circumstances. It's advisable to have an emergency fund 
                      in place before making long-term investments and to seek professional guidance from NISM certified distributors 
                      based on your individual situation.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WelcomeSection;